import { z } from "zod";
import { defineStepConfig } from "../registry";
import { SystemEvent } from "@erp/shared-types";

// Input schema - no inputs, this is an entry point
const inputSchema = z.never();

const EVENTS_WITH_EXTRA_CONFIG = [SystemEvent.EMAIL_ROUTED_EMAIL_RULE] as const;

const FALLBACK_EVENT_TYPES = Object.values(SystemEvent).filter(
  (
    eventType,
  ): eventType is Exclude<
    SystemEvent,
    (typeof EVENTS_WITH_EXTRA_CONFIG)[number]
  > =>
    !EVENTS_WITH_EXTRA_CONFIG.includes(
      eventType as (typeof EVENTS_WITH_EXTRA_CONFIG)[number],
    ),
);

const fallbackEventTypeSchema = z.enum(
  FALLBACK_EVENT_TYPES as [string, ...string[]],
  {
    error: () =>
      "Event type must be one of the following: " +
      FALLBACK_EVENT_TYPES.join(", "),
  },
);

const configSchema = z.discriminatedUnion("eventType", [
  z.object({
    eventType: z.literal(SystemEvent.EMAIL_ROUTED_EMAIL_RULE),
    emailRuleOptionId: z.uuid(),
  }),
  // all event types without other config
  z.object({
    eventType: fallbackEventTypeSchema,
  }),
]);

export type EventTriggerConfig = z.infer<typeof configSchema>;

// Output schema - contains the event data
// Creates a discriminated union of all possible event schemas from SystemEventMap
const outputSchema = z.object({
  eventData: z.any(), // TODO hopefully one day this will be a discriminated union based on the eventType
});

// No emissions from trigger steps
const emits = [] as const;

export const eventTriggerStep = defineStepConfig({
  type: "event_trigger",
  name: "Event Trigger",
  description: "Entry point for workflows triggered by system events",
  category: "Trigger",
  inputSchema,
  outputSchema,
  configSchema,
  emits,
});
